import {isNotNilOrEmpty} from 'ramda-adjunct';

import {
  useGetCebiaAutotracerAndReportConfigQuery,
  useGetCebiaFeatureDecoderConfigQuery,
  useGetCebiaRokvyConfigQuery,
} from '@dms/api/core';

export function useIntegrationsEnabled() {
  const {data: cebiaAutotracerAndReportConfig} = useGetCebiaAutotracerAndReportConfigQuery();
  const {data: cebiaRokvyConfig} = useGetCebiaRokvyConfigQuery();
  const {data: featureDecoderConfig} = useGetCebiaFeatureDecoderConfigQuery();

  const isCebiaFeatureDecoderEnabled = Boolean(
    featureDecoderConfig?.enabled && featureDecoderConfig?.credentials?.username
  );

  return {
    // Autotracer and Report
    isCebiaAutotracerAndReportEnabled: cebiaAutotracerAndReportConfig?.enabled,
    isCebiaAutotracerAndReportCredentialsValid:
      cebiaAutotracerAndReportConfig?.enabled &&
      isNotNilOrEmpty(cebiaAutotracerAndReportConfig?.credentials?.username),
    // Rokvy
    isCebiaRokvyEnabled: cebiaRokvyConfig?.enabled,
    isCebiaRokvyCredentialsValid:
      cebiaRokvyConfig?.enabled && isNotNilOrEmpty(cebiaRokvyConfig?.credentials?.username),
    // Feature Decoder
    isCebiaFeatureDecoderEnabled,
    isCebiaFeatureDecoderCredentialsValid:
      isCebiaFeatureDecoderEnabled && isNotNilOrEmpty(featureDecoderConfig?.credentials?.username),
  };
}
